import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../../Utils/i18next/i18next";

export const onSubmit = async (values, props) => {
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    initialValues,
  } = props;

  const data = Object.values(values)
    .filter((el) => typeof el === "object")
    .map((el) => {
      if (
        el &&
        typeof el === "object" &&
        el.value &&
        typeof el.value === "object" &&
        "value" in el.value
      ) {
        return {
          ...el,
          value: el.value.value,
        };
      }
      return el;
    })
    .map((el) => {
      if (!el.name && initialValues?.CHECKLIST_TEXT?.name) {
        return {
          ...initialValues.CHECKLIST_TEXT,
          value: el.value,
        };
      }
      return el;
    });

  let payload;

  if (!update) {
    // możliwe do rozbudowania
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/settings`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);
    props.setErrorHeader(1, true);

    return;
  }

  props.setErrorHeader(0, false);
  props.setErrorHeader(1, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  props.handleHide();
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};
  const errorsStep1 = {};

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }
  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }

  return { ...errorsStep0, ...errorsStep1 };
};
